"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompareOfferButton = void 0;
const react_1 = require("react");
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const CompareOfferButtonState_1 = __importDefault(require("@react/web/Common/CompareOfferButton/CompareOfferButtonState"));
const ErrorMessageEnum_1 = require("@react/web/Common/CompareOfferButton/ErrorMessageEnum");
const gtmEvent_1 = __importDefault(require("@react/web/Common/CompareOfferButton/gtmEvent"));
const IsInComparatorResolver_1 = __importDefault(require("@react/web/Common/CompareOfferButton/IsInComparatorResolver"));
const PriceOfferUrlData_1 = __importDefault(require("@react/web/Common/CompareOfferButton/PriceOfferUrlData"));
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
function useCompareOfferButton(currentDisplayedPriceOffer) {
    const [componentState, setComponentState] = (0, react_1.useState)(CompareOfferButtonState_1.default.LOADING);
    const [isPriceOfferInComparator, setIsPriceOfferInComparator] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(null);
    const updateComparatorPriceOffersCount = (currentComparisonOfferCount) => {
        const itemsCounter = document.getElementById('comparison-items-count');
        const comparatorPanel = document.getElementById('comparator-panel');
        const comparatorPanelItemsCounter = document.getElementById('comparator-panel-items-count');
        const headerComparePriceOffersLink = document.getElementById('header-compare-price-offers-link');
        if (itemsCounter && comparatorPanelItemsCounter && comparatorPanel && headerComparePriceOffersLink) {
            itemsCounter.innerHTML = currentComparisonOfferCount.toString();
            if (currentComparisonOfferCount === 0) {
                document.body.classList.remove('comparator-panel-visible');
            }
            else {
                comparatorPanel.classList.add('highlight');
                document.body.classList.add('comparator-panel-visible');
                comparatorPanelItemsCounter.innerHTML = currentComparisonOfferCount.toString();
                setTimeout(() => {
                    comparatorPanel.classList.remove('highlight');
                }, 2000);
            }
            const updateTooltipEvent = new CustomEvent('updateTooltipEvent', {
                detail: {
                    count: currentComparisonOfferCount,
                },
            });
            headerComparePriceOffersLink.dispatchEvent(updateTooltipEvent);
        }
    };
    const setupErrorMessage = (messageType) => {
        setErrorMessage((0, ErrorMessageEnum_1.ErrorMessageEnum)(messageType));
        setComponentState(CompareOfferButtonState_1.default.READY);
    };
    const handleAddToComparator = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(CompareOfferButtonState_1.default.SENDING);
            const url = SymfonyRouter_1.default.getRoute('api.car_offer.subscription.price_offer.add_comparison', (0, PriceOfferUrlData_1.default)(currentDisplayedPriceOffer));
            fetch(url, {
                method: 'PUT',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        const currentComparisonOfferCount = json.current_comparison_price_offer_count;
                        (0, gtmEvent_1.default)(currentDisplayedPriceOffer.priceOfferId);
                        updateComparatorPriceOffersCount(currentComparisonOfferCount);
                        setIsPriceOfferInComparator(true);
                        setComponentState(CompareOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.ADD);
                }
            })
                .catch((e) => {
                console.warn(`Catch handleAddToComparator error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.ADD);
            });
        }
    };
    const handleRemoveFromComparator = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(CompareOfferButtonState_1.default.SENDING);
            const url = SymfonyRouter_1.default.getRoute(currentDisplayedPriceOffer.inquiryType === PageHelper_1.InquiryOfferTypesEnum.FIXTERM
                ? 'api.car_offer.subscription.price_offer.remove_from_comparison_fixterm'
                : 'api.car_offer.subscription.price_offer.remove_from_comparison', (0, PriceOfferUrlData_1.default)(currentDisplayedPriceOffer));
            fetch(url, {
                method: 'DELETE',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        const currentComparisonOfferCount = json.current_comparison_price_offer_count;
                        updateComparatorPriceOffersCount(currentComparisonOfferCount);
                        setIsPriceOfferInComparator(false);
                        setComponentState(CompareOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.REMOVE);
                }
            })
                .catch((e) => {
                console.warn(`Catch handleRemoveFromComparator error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.REMOVE);
            });
        }
    };
    const handleRemoveErrorMessage = () => {
        setupErrorMessage(null);
    };
    const handleRemoveAllFromComparator = () => {
        setIsPriceOfferInComparator(false);
    };
    const checkPriceOfferIsInComparator = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(CompareOfferButtonState_1.default.LOADING);
            const url = SymfonyRouter_1.default.getRoute('api.car_offer.subscription.price_offer.comparison_checker', {
                carOfferId: currentDisplayedPriceOffer.subscriptionOfferId,
            });
            fetch(url, {
                method: 'GET',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        const priceOffersInComparator = json.price_offer_response;
                        setIsPriceOfferInComparator((0, IsInComparatorResolver_1.default)(currentDisplayedPriceOffer, priceOffersInComparator));
                        setComponentState(CompareOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.LOAD);
                }
            })
                .catch((e) => {
                console.warn(`Catch checkPriceOfferIsInComparator error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.LOAD);
            });
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('comparator.remove_all_from_comparison', handleRemoveAllFromComparator);
    }, []);
    (0, react_1.useEffect)(() => {
        checkPriceOfferIsInComparator();
    }, [currentDisplayedPriceOffer]);
    return {
        handleAddToComparator,
        handleRemoveFromComparator,
        handleRemoveErrorMessage,
        componentState,
        isPriceOfferInComparator,
        errorMessage,
    };
}
exports.useCompareOfferButton = useCompareOfferButton;
